import { useSaveAssetProgress } from '@hub-la/fe-asset';
import { useContainer } from '@hub-la/fe-container';
import { Analytics } from '@hub-la/fe-core-analytics';
import { useCallback } from 'react';
import '../../domain/dtos/alert-type.js';
import '../../domain/dtos/error-type.js';
import { Events } from '../../domain/dtos/events.js';
import '../../domain/dtos/main-content-type.js';
import '../../domain/dtos/post-event-type.js';
import '../../domain/dtos/post-status.js';
import '../../domain/dtos/query-key.js';
import '../../domain/dtos/remove-dialog-action.js';
import { useGetSectionProgress } from './use-get-section-progress.js';
import { useRealtimeSections } from './use-realtime-sections.js';

const useUserProgress = ({
  assetId,
  sectionId,
  postId,
  progress
}) => {
  const container = useContainer();
  const analytics = container.get(Analytics);
  const {
    dispatch,
    sections
  } = useRealtimeSections();
  const {
    mutateAsync: getSectionProgress
  } = useGetSectionProgress();
  const saveAssetProgress = useSaveAssetProgress();
  const updateUserProgress = useCallback((currentTime, totalTime) => {
    dispatch({
      type: 'update',
      sectionId,
      postId,
      currentTime
    });
    getSectionProgress(sectionId).then(sectionProgress => dispatch({
      type: 'update',
      sectionId,
      postId,
      currentTime,
      sectionProgress
    }));
    saveAssetProgress.mutateAsync({
      assetId,
      total: totalTime,
      currentProgress: currentTime
    }).catch(() => {
      analytics.track(Events.HUB.PROGRESS.SAVE_FAILED, {
        assetId,
        type: 'video',
        userProgress: progress !== null && progress !== void 0 ? progress : 0,
        current: currentTime,
        total: totalTime
      });
    });
  }, [analytics, assetId, saveAssetProgress, sections, dispatch, sectionId, postId]);
  return {
    updateUserProgress
  };
};

export { useUserProgress };
